import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import PageWrapper from '../../page-wrapper';
import sharedStyles from '../../styles';
import breakpoints from '../../breakpoints';
import Testimonial from '../../Testimonial';

const InnerContainer = styled.div`
  display: flex;
  max-width: ${breakpoints.xl};
  margin-block: ${sharedStyles.spacing['spacing-2xl']};
  flex-direction: column;
`;

const Headline = styled.h2`
  margin: 0 auto ${sharedStyles.spacing['spacing-md']} auto;
  text-align: center;
`;

const TestimonialGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${sharedStyles.spacing['spacing-lg']};

  @media screen and (min-width: ${breakpoints.sm}) {
    justify-content: center;

    > div {
      width: calc(50% - ${sharedStyles.spacing['spacing-lg']});
    }
  }

  @media screen and (min-width: ${breakpoints.xl}) {
    flex-wrap: nowrap;

    > div {
      width: 100%;
    }
  }
`;

function BlockBuilderTestimonial({ value }) {
  return (
    <PageWrapper fullWidth background="transparent" padding="0">
      <InnerContainer layout={value?.desktopLayout}>
        {value?.headline && <Headline>{value?.headline}</Headline>}
        <TestimonialGroup>
          {value?.items?.length > 0 &&
            value.items.map(item => (
              <Testimonial
                // eslint-disable-next-line no-underscore-dangle
                key={item._key}
                quote={item?.testimonialQuote}
                author={item?.testimonialQuoteAuthor}
                location={item?.testimonialLocation}
              />
            ))}
        </TestimonialGroup>
      </InnerContainer>
    </PageWrapper>
  );
}

BlockBuilderTestimonial.propTypes = {
  value: PropTypes.shape({
    headline: PropTypes.string,
    desktopLayout: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
};

export default BlockBuilderTestimonial;
